export default{
    title:'Filters',
    buttonText:'clear',
    btnId:'example_',
    buttonVariant:'none',
    emptyString:''
};